import script from "./CreateSettingsProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateSettingsProfile.vue?vue&type=script&lang=ts&setup=true"

import "./CreateSettingsProfile.vue?vue&type=style&index=0&id=0661ec08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0661ec08"]])

export default __exports__